import {Component, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef} from '@angular/core';

import { DefaultEditor} from 'ng2-smart-table';
import {ContactModel, EBusinessType, EContactType, TopicActionModel} from '../../../../@models';
import {CompleterData, CompleterItem, CompleterService} from 'ng2-completer';
import {ApiService} from '../../../../@core/service/api.service';
import {Subject} from 'rxjs';
import {NbToastrService} from '@nebular/theme';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { mongoId } from '../../../../@core/common/global';

@Component({
  template: `
    <div class="row">
      <div class="col-4">Responsible</div>
      <div class="col-8">
        <div class="form-check">
          <input type="checkbox" [(ngModel)]="isExternal" class="form-check-input">
          <label class="form-check-label" style="margin-left: 2rem;">free entry</label>
        </div>
        <input type="text"
               *ngIf="isExternal"
               [(ngModel)]="newParticipantName"
               class="form-control form-control-sm">
        <div class="form-check" *ngIf="!isExternal">
          <input type="checkbox"
                 [(ngModel)]="onlyCustomer"
                 class="form-check-input"
                 (change)="selectOnlyCustomer(onlyCustomer)">
          <label class="form-check-label" style="margin-left: 2rem;">only customer</label>
        </div>
        <div class="form-check" *ngIf="!isExternal">
          <input type="checkbox" [(ngModel)]="onlyNrk" class="form-check-input" (change)="selectOnlyNrk(onlyNrk)">
          <label class="form-check-label" style="margin-left: 2rem;">only nrk</label>
        </div>
        <!-- <ng2-completer *ngIf="!isExternal"
                      [(ngModel)]="newParticipantName"
                      [datasource]="contactService"
                      [minSearchLength]="0"
                      (selected)="select($event)"
                      inputClass="form-control form-control-sm"
        ></ng2-completer> -->
        <ngx-doc-form-filter-select [(value)]="participant" [options]="data.nrkContactOptions"></ngx-doc-form-filter-select>

      </div>
    </div>
    <ngx-form-text [(value)]="newAction" title="Action"></ngx-form-text>

    <ngx-form-date [(value)]="newDate" title="Due Date"></ngx-form-date>
    <button class="btn btn-primary btn-sm" (click)="addParticipant()">Insert</button>

     <div *ngFor="let item of cell.newValue" [class.completed]="item.completed">
       <i class="ion-person"></i>&nbsp;{{item.name}}&nbsp;
       <i class="ion-information-circled"></i>&nbsp;{{item.action}}&nbsp;
       <i class="ion-calendar"></i>&nbsp;{{item.date | date:'dd. MM. yyyy'}}
       <a (click)="remove(item)" [routerLink]="[]">X</a>
     </div>
  `,
  styles: [
    '.completed { color: #aaaaaa; }',
  ],
})

export class FormListActionplanEditComponent extends DefaultEditor implements AfterViewInit {

  JSON = JSON;

  contactService: CompleterData;

  public static businessId: string;
  public static instance: FormListActionplanEditComponent;


  isExternal: boolean;
  onlyCustomer: boolean = true;
  onlyNrk: boolean = true;

  newParticipantName: string;
  newParticipant: ContactModel;
  newAction: string;
  newDate: string;
  participant: string;

  private contactSubject = new Subject();


  constructor(
    private api: ApiService,
    // private completerService: CompleterService,
    private toastrService: NbToastrService,
    private cdRef: ChangeDetectorRef,
    protected data: SharedDataService,
  ) {
    super();
    // this.contactService = this.completerService.local(this.contactSubject, 'displayTitle', 'displayTitle');
    /* this.api.reloadContacts({contactType: EContactType.Employee}), 'displayTitle', 'displayTitle')*/
    // this.reload();
  }

  ngAfterViewInit(): void {
    if (this.cell.newValue == null) this.cell.newValue = [];
    if (!Array.isArray(this.cell.newValue)) this.cell.newValue = [];
    this.data.loadContacts();
    this.reload();
    FormListActionplanEditComponent.instance = this;
  }
  // continue here!!

  selectOnlyCustomer(value: Boolean) {
    this.reload();

    // this.contactService.dataSourceChange =
    // this.api.reloadContacts({contactType: EContactType.Employee});
  }


  selectOnlyNrk(value: Boolean) {
    this.reload();
  }


  private reload() {
    const filter: any = {contactType: EContactType.Employee};
    if (this.onlyNrk) filter.type = EBusinessType.NRK;
    if (this.onlyCustomer && FormListActionplanEditComponent.businessId)
      filter.business = FormListActionplanEditComponent.businessId;


    this.api.reloadContacts(filter).subscribe(x => this.contactSubject.next(x));
    this.cdRef.detectChanges();
  }



  isDirty(): boolean {
    if (this.newParticipantName != null && this.newParticipantName.length > 0) return true;
    return this.newAction != null && this.newAction.length > 0;
  }


  addParticipant(): boolean {

    console.log('new Participent', this.participant, this.newParticipant, this.newParticipantName);

    // if (!this.newParticipant) return false;
    if (!this.participant) return false;

    this.newParticipant = this.data.contacts.find(f => mongoId(f) === mongoId(this.participant));
    this.newParticipantName = this.newParticipant.title;
    
    if (this.cell.newValue == null) this.cell.newValue = [];
    if (this.newParticipantName == null || this.newParticipantName.length === 0) {
      this.toastrService.danger('Participant name required', 'Error');
      return false;
    }
    if (this.newAction == null || this.newAction.length === 0) {
      this.toastrService.danger('Action is required', 'Error');
      return false;
    }


    if (this.isExternal) {

      this.cell.newValue.push({
        contact: null,
        name: this.newParticipantName,
        action: this.newAction,
        date: this.newDate,
      })
    } else {
      this.cell.newValue.push({
        contact: this.newParticipant._id,
        name: this.newParticipant.title,
        action: this.newAction,
        date: this.newDate,
      });
    }

    this.newParticipant = null;
    this.newParticipantName = '';
    this.participant = null;
    this.newDate = null;
    this.newAction = '';
    return true
  }

  // select(item: CompleterItem) {
  //   if (item != null)
  //     this.newParticipant = item.originalObject;
  // }

  remove(item: TopicActionModel) {
    this.cell.newValue = this.cell.newValue.filter(x => x.name !== item.name)
  }
}
